import programRoutes from '../../../routes/admin/programRoutes';

function Program() {
  return programRoutes;
}

export default Program;
